import React, {Component} from 'react'

import Background from '../common/Background'
import {TimelineMax, Power2} from 'gsap'


// Import Images
import aboutBG from '../../assets/images/about/about-bg.jpg'
import logo from '../../assets/images/hart.svg'


// import client's logos

import kn from '../../assets/images/about/clients/kn.png'
import kfc from '../../assets/images/about/clients/kfc.png'
import bk from '../../assets/images/about/clients/burger-king.png'
import ph from '../../assets/images/about/clients/pizza-hut.png'
import jub from '../../assets/images/about/clients/jubilee.png'
import volka from '../../assets/images/about/clients/volka.png'
import conti from '../../assets/images/about/clients/continental.png'
import hashmi from '../../assets/images/about/clients/hashmi.png'
import hardees from '../../assets/images/about/clients/hardees.png'
import subway from '../../assets/images/about/clients/subway.png'
import asim from '../../assets/images/about/clients/asim.png'
import toshiba from '../../assets/images/about/clients/toshiba.png'
import lotte from '../../assets/images/about/clients/lotte.png'
import mon from '../../assets/images/about/clients/mon-salwa.png'
import dhl from '../../assets/images/about/clients/dhl.png'
import fp from '../../assets/images/about/clients/foodpanda.png'
import albakara from '../../assets/images/about/clients/albaraka.png'
import tapal from '../../assets/images/about/clients/tapal.png'
import toyota from '../../assets/images/about/clients/toyota.png'
import khadi from '../../assets/images/about/clients/khadi.png'
import ubl from '../../assets/images/about/clients/ubl.png'
// import shezan from '../../assets/images/about/clients/shezan.png'


class About extends Component {


    componentDidMount() {

        if (window.innerWidth > 768) {
            // Object Setting

            const image = document.getElementsByClassName('image-holder')
            const logo_holder = document.getElementsByClassName('logo-holder')
            const heading = document.getElementsByClassName('about-heading')
            const heading_small = document.getElementsByClassName('about-heading-small')

            // Define
            let aboutTimeline = new TimelineMax();

            // Setter
            aboutTimeline.set(image, {scale: 1, opacity: 0})
            aboutTimeline.set(logo_holder, {opacity: 0, y: '-100'})
            aboutTimeline.set(heading, {opacity: 0, x: '50'})
            aboutTimeline.set(heading_small, {x: '-150', opacity: 0})

            //Animation
            aboutTimeline.to(image, 2.5,
                {
                    scale: 1,
                    opacity: 1,
                    force3D: false,
                    ease: Power2.easeOut
                })
                .to(logo_holder, 2,
                    {
                        opacity: 1,
                        y: '0',
                        force3D: false,
                        ease: Power2.easeOut
                    }, '-=1')
                .to(heading_small, 1.5,
                    {
                        x: 0,
                        opacity: 1,
                        force3D: false,
                        ease: Power2.easeOut
                    }, '-=1.5')
                .to(heading, 1.5,
                    {
                        opacity: 1,
                        x: 0,
                        force3D: false,
                        ease: Power2.easeOut
                    }, '-=1')
        }
    }

    render() {

        return (
            <div id="about">
                <div className="image-holder">
                    <Background src={aboutBG}/>
                </div>
                <div className="content">
                    <div className="logo-holder">
                        <img src={logo} alt=""/>
                    </div>

                    <h2>
                        <small className="about-heading-small">
                            OUR AIM IS COMPLETE
                        </small>
                        <span className="about-heading"> CUSTOMER SATISFACTION</span>
                    </h2>

                    <p >
                        Hart Communications Pvt. Ltd. does not exist as a mere business enterprise. Rather, we
                        believe
                        in providing complete customer satisfaction to our clients through our efficient media
                        planning
                        and buying, BTL activation and event management services.
                    </p>
                    <p>
                        Since its inception in 2012, Hart Communications Pvt. Ltd. has developed a good reputation
                        in
                        the out-of-home media industry through its commitment and dedication towards satisfying its
                        clients. At Hart Communications Pvt. Ltd., customer satisfaction is considered a key driver
                        towards achieving business excellence.
                    </p>

                    <p >
                        Despite being relatively new in the field, the reason why some of the most well-known
                        Pakistani
                        brands choose us as their Outdoor Media Agency (OMA) is because we help our clients explore
                        various possibilities, guide them, suggest creative ideas and motivate them by providing the
                        best outdoor media solutions for their products and services.
                    </p>
                </div>

                {/* Clients and Stakeholders */}
                <div id="clients">
                    <h3 className="clients-heading">Clients and Stakeholders</h3>
                    <div className="container">
                        <div className="table-row">
                            <div className="cell">
                                <img src={kn} alt="K&ns"/>
                            </div>
                            <div className="cell">
                                <img src={kfc} alt="KFC"/>
                            </div>
                            <div className="cell">
                                <img src={bk} alt="Burger King"/>
                            </div>
                        </div>
                        <div className="table-row">
                            <div className="cell">
                                <img src={ph} alt="Pizza Hut"/>
                            </div>
                            <div className="cell">
                                <img src={jub} alt="Jubilee Insurance"/>
                            </div>
                            <div className="cell">
                                <img src={volka} alt="Volka"/>
                            </div>
                        </div>
                        <div className="table-row">
                            <div className="cell">
                                <img src={conti} alt="Continental"/>
                            </div>
                            <div className="cell">
                                <img src={hashmi} alt="Hashim"/>
                            </div>
                            <div className="cell">
                                <img src={hardees} alt="Hardees"/>
                            </div>
                        </div>
                        <div className="table-row">
                            <div className="cell">
                                <img src={subway} alt="Subway"/>
                            </div>
                            <div className="cell">
                                <img src={asim} alt="Asim Jofa"/>
                            </div>
                            <div className="cell">
                                <img src={toshiba} alt="Toshiba"/>
                            </div>
                        </div>

                        <div className="table-row">
                            <div className="cell">
                                <img src={lotte} alt="Lotte"/>
                            </div>
                            <div className="cell">
                                <img src={mon} alt="ManSalwa"/>
                            </div>
                            <div className="cell">
                                <img src={dhl} alt="DHL"/>
                            </div>
                        </div>

                        <div className="table-row">
                            <div className="cell">
                                <img src={fp} alt="FoodPanda"/>
                            </div>
                            <div className="cell">
                                <img src={albakara} alt="albakara"/>
                            </div>
                            <div className="cell">
                                <img src={tapal} alt="tapal"/>
                            </div>
                        </div>

                        <div className="table-row">
                            <div className="cell">
                                <img src={toyota} alt="toyota"/>
                            </div>
                            <div className="cell">
                                <img src={khadi} alt="khadi"/>
                            </div>
                            <div className="cell">
                                <img src={ubl} alt="UBL"/>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}
export default About


// WEBPACK FOOTER //
// ./src/components/Pages/About.js